export const SET_FIELD = 'SET_FIELD';

export const CALCULATE = 'CALCULATE';

export const CALCULATE_INCOME = 'CALCULATE_INCOME';

export const CALCULATE_YEARLY_INCOME = 'CALCULATE_YEARLY_INCOME';

export const CALCULATE_YEARLY_INCOME_INDEPENDENT = 'CALCULATE_YEARLY_INCOME_INDEPENDENT';

export const GET_BANK_BY_ID = 'GET_BANK_BY_ID';

export const SET_OTHER_BANK = 'SET_OTHER_BANK';

export const GET_SUMMARY_PDF = 'GET_SUMMARY_PDF';

export const GET_MORTGAGE_PROVIDER = 'GET_MORTGAGE_PROVIDER';

export const SHARE_PDF = 'SHARE_PDF';

export const RESET_STEPS = "RESET_STEPS";
